/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@Thread-Magic/jasmine';
import { FiPlus } from 'react-icons/fi';

import InfoCard from 'src/components/InfoCard';
import IntentArgument from '../IntentArgument';

import { IntentBlock } from './style';

const VariationArguments = ({
  variationArguments,
  handleRemoveArgument,
  handleAddFormField,
  handleChangeFormField
}) => (
  <IntentBlock>
    <div>
      <InfoCard>This is the information the Agent will collect from the contact.</InfoCard>
      <p>Form</p>
      {variationArguments?.map(item => {
        return (
          <IntentArgument
            onRemove={() => handleRemoveArgument(item.id)}
            key={item.id}
            data={item}
            onChange={newdata => handleChangeFormField(newdata)}
          />
        );
      })}
      <Button onClick={() => handleAddFormField()} type="button">
        <FiPlus />
        Add form field
      </Button>
    </div>
  </IntentBlock>
);

VariationArguments.propTypes = {
  variationArguments: PropTypes.objectOf(PropTypes.any),
  handleRemoveArgument: PropTypes.func,
  handleChangeFormField: PropTypes.func,
  handleAddFormField: PropTypes.func
};

VariationArguments.defaultProps = {
  variationArguments: [],
  handleChangeFormField: () => {},
  handleRemoveArgument: () => {},
  handleAddFormField: () => {}
};

export default VariationArguments;
